export default __webpack_public_path__ + "c85824f0309b6a56bca05bc15b2389b0.png";